import { RootState } from '../..';
import { ListPriceBoardData } from './types';

export const selectListPriceBoard = (state: RootState): ListPriceBoardData[] => state.public.listPriceBoard.list;
export const selectListPriceBoardLoading = (state: RootState) => state.public.listPriceBoard.loading;
export const selectListPriceBoardError = (state: RootState) => state.public.listPriceBoard.error;
